import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["decreaseBtn", "increaseBtn", "input", "message"]
  }

  static get values() {
    return {
      disabled: { type: Boolean, default: false },
    }
  }

  connect() {
    this.minValue = parseFloat(this.inputTarget.getAttribute("min")) || 0
    this.maxValue = parseFloat(this.inputTarget.getAttribute("max")) || 9999

    this.checkValue()
  }

  increase() {
    const newValue = parseFloat(this.inputTarget.value) + 1

    if (newValue < this.maxValue) {
      this.inputTarget.value = newValue
    } else if (newValue === this.maxValue) {
      this.inputTarget.value = newValue
    }

    this._updateButtons()
  }

  decrease() {
    const newValue = parseFloat(this.inputTarget.value) - 1

    if (newValue > this.minValue) {
      this.inputTarget.value = newValue
    } else if (newValue === this.minValue) {
      this.inputTarget.value = newValue
    }

    this._updateButtons()
  }

  checkValue() {
    if (this.inputTarget.value > this.maxValue || this.inputTarget.value < this.minValue) {
      this._displayMessage(
        i18n.t("js.back.quantity_selector.error_message", { min: this.minValue, max: this.maxValue }),
      )
    } else {
      this._hideMessage()
    }

    if (this.inputTarget.value > this.maxValue) {
      this.inputTarget.value = this.maxValue
    } else if (this.inputTarget.value < this.minValue) {
      this.inputTarget.value = this.minValue
    }

    this._updateButtons()
  }

  _updateButtons() {
    if (this.disabledValue === true) {
      this.increaseBtnTarget.setAttribute("disabled", "true")
      this.inputTarget.setAttribute("disabled", "true")
      this.inputTarget.setAttribute("readonly", "true")
      this.decreaseBtnTarget.setAttribute("disabled", "true")
    } else if (this.inputTarget.value >= this.maxValue) {
      this.increaseBtnTarget.setAttribute("disabled", "true")
      this.decreaseBtnTarget.removeAttribute("disabled")
    } else if (this.inputTarget.value <= this.minValue) {
      this.decreaseBtnTarget.setAttribute("disabled", "true")
      this.increaseBtnTarget.removeAttribute("disabled")
    } else {
      this.decreaseBtnTarget.removeAttribute("disabled")
      this.increaseBtnTarget.removeAttribute("disabled")
    }
  }

  _displayMessage(text) {
    if (this.hasMessageTarget) {
      this.messageTarget.innerHTML = text
    }
  }

  _hideMessage() {
    if (this.hasMessageTarget) {
      this.messageTarget.innerHTML = null
    }
  }
}
